import { lazy } from "react";
// Lab Phlebotomy Module
// Manages lab phlebotomy records and appointments

const LabPhlebotomyPage = lazy(() => import("./pages/LabPhlebotomyPage"));
const LabPhlebotomyCreatePage = lazy(() => import("./pages/LabPhlebotomyCreatePage"));
// Sección Lab Intake (doc MCOS "Sante Plus Lab Intake and In-House Testing")
const LabIntakePage = lazy(() => import("./pages/LabIntakePage"));
const LabIntakeCreatePage = lazy(() => import("./pages/LabIntakeCreatePage"));
// Export routes for AppRouter
export const labPhlebotomyRoutes = [
  {
    path: "/LabPhlebotomy",
    element: <LabPhlebotomyPage />,
  },
  {
    path: "/LabPhlebotomy/create",
    element: <LabPhlebotomyCreatePage />,
  },
  {
    path: "/LabPhlebotomy/edit/:recordId",
    element: <LabPhlebotomyCreatePage />,
  },
  // Lab Intake: mismo prefijo de URL, hereda el RBAC de lab_phlebotomy
  {
    path: "/LabPhlebotomy/intake",
    element: <LabIntakePage />,
  },
  {
    path: "/LabPhlebotomy/intake/create",
    element: <LabIntakeCreatePage />,
  },
  {
    path: "/LabPhlebotomy/intake/edit/:recordId",
    element: <LabIntakeCreatePage />,
  },
];

// Export components for external use
export { default as LabPhlebotomyTable } from "./components/LabPhlebotomyTable";

// Export utilities
export {
  getLabPhlebotomyRecords,
  getLabPhlebotomyRecordById,
  createLabPhlebotomyRecord,
  updateLabPhlebotomyRecord,
  deleteLabPhlebotomyRecord,
  getCountsByMedicalCenter,
} from "./utils/labPhlebotomyStorage";
export * from "./constants/labPhlebotomyOptions";

// API Service functions (canonical source: specialist-referrals/services)
export {
  createLabPhlebotomy,
  updateLabPhlebotomy,
  deleteLabPhlebotomy,
  getLabPhlebotomyList,
  getLabPhlebotomyById,
  getPatientsWithActiveReferrals,
} from "../specialist-referrals/services/labPhlebotomyService";
